import React from "react";
import { Card, CardHeader, CardBody, Row, Col } from "reactstrap";

const cardShell = {
  background: "var(--vz-secondary-bg, #fff)",
  border: "1px solid var(--vz-border-color)",
  borderRadius: 10,
  boxShadow: "0 1px 4px rgba(0,0,0,0.06)",
  overflow: "hidden",
};

const pageIconWrapStyle = {
  width: 32,
  height: 32,
  borderRadius: 8,
  border: "1px solid rgba(var(--vz-primary-rgb), 0.35)",
  background: "rgba(var(--vz-primary-rgb), 0.08)",
  display: "inline-flex",
  alignItems: "center",
  justifyContent: "center",
  flexShrink: 0,
};

const pageIconStyle = {
  color: "var(--vz-primary)",
  fontSize: 16,
};

const Tile = ({ label, value }) => (
  <div
    style={{
      border: "1px solid rgba(255,255,255,0.06)",
      borderRadius: "6px",
      padding: "12px",
      textAlign: "center"
    }}
  >
    <p className="text-muted mb-1" style={{ fontSize: "12px" }}>
      {label}
    </p>

    <h4 className="mb-0">{value}</h4>
  </div>
);

const AuthenticationAccess = () => {
  return (
    <Card style={{...cardShell, border: "1px solid rgba(255,255,255,0.05)" }} className="h-100">

      <CardHeader className="bg-light">
        <h5 className="card-title mb-0">
          <div style={pageIconWrapStyle} className="me-2">
            <i className="ri-lock-line" style={pageIconStyle} ></i>
          </div>
          Authentication & Access
        </h5>
      </CardHeader>

      <CardBody>

        {/* Failed Auth Attempts */}
        <div
          className="d-flex align-items-center mb-3"
          style={{
            border: "1px solid rgba(239,68,68,0.35)",
            borderRadius: "6px",
            padding: "12px",
            background: "rgba(239,68,68,0.05)"
          }}
        >
          <div
            className="me-3 d-flex align-items-center justify-content-center"
            style={{
              width: 38,
              height: 38,
              borderRadius: "50%",
              background: "rgba(239,68,68,0.15)",
              color: "#ef4444"
            }}
          >
            <i className="ri-error-warning-line"></i>
          </div>

          <div>
            <small className="text-muted">FAILED AUTH ATTEMPTS</small>
            <h3 className="mb-0" style={{ color: "#ef4444" }}>
              142
            </h3>
          </div>
        </div>

        {/* Stats Tiles */}
        <Row className="g-3">

          <Col md={6}>
            <Tile label="UNTRUSTED ACCESS" value="14" />
          </Col>

          <Col md={6}>
            <Tile label="SHARED ACCOUNT USE" value="06" />
          </Col>

          <Col md={6}>
            <Tile label="PRIVILEGED USAGE" value="28" />
          </Col>

          <Col md={6}>
            <Tile label="REMOTE SESSIONS" value="09" />
          </Col>

        </Row>

      </CardBody>

    </Card>
  );
};

export default AuthenticationAccess;
